import { appApis } from "../constants";
import reduxKeys from "../constants/reduxKeys";
import { encodeAndSave, getMenuData, showToast } from "../utils";
import HttpClient from "./http-client"

export const setUserData = (dispatch, data) => {
    dispatch({ type: reduxKeys.SET_USER_DATA, payload: data });
}

export const loginUser = (payload, callback) => {
    return (dispatch) => {
        new HttpClient().post(appApis.login, payload).then(response => {
            if (response?.data?.data) {
                const token = response?.data?.data?.token || "";
                if (token) {
                    const userDetails = response?.data?.data?.user || {};
                    localStorage.setItem("access_token", token);
                    const userData = { ...userDetails, token }
                    encodeAndSave("userData", JSON.stringify(userData));
                    setUserData(dispatch, userData)
                }
                showToast(response?.data?.message ?? "", "success");
            }
        }).catch((ex) => {
            if (callback) callback(null)
            showToast(ex.response?.data?.message ?? "", "error");
        });
    }
}

export const userAllowedPages = (userId) => {
    return (dispatch) => {
        new HttpClient().get(`${appApis.pages}/${userId}`).then(response => {
            const pages = response?.data?.data || [];
            const allowedPageNames = getMenuData(pages);
            dispatch({ type: reduxKeys.SET_ALLOWED_PAGES, payload: allowedPageNames });
        }).catch(ex => {
            console.error("Error fetching allowed pages: ", ex);
            dispatch({ type: reduxKeys.SET_ALLOWED_PAGES, payload: [] });
        });
    };
};

